import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";

const RunsheetListComponent = loadable(
  () => import("../../components/Runsheet/RunsheetList")
);

const RunsheetList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Runsheet</span>
      </div>
      <RunsheetListComponent />
    </>
  );
};

export default RunsheetList;